module.exports = __webpack_public_path__ + "static/media/signup-password.00716231.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/login/signup-password.png
// module id = 773
// module chunks = 0